<div class="flex min-h-screen bg-[#F3F4F6] font-sans">

  <aside class="w-64 bg-[#5b21b6] text-white flex flex-col shrink-0">
    <div class="p-6 flex items-center gap-3">
      <app-logo></app-logo>
    </div>

    <nav class="flex-1 px-4 space-y-2 mt-4">
      <a routerLink="/intake"
         class="flex items-center gap-3 px-4 py-3 text-white/80 hover:bg-white/10 rounded-lg font-medium transition-colors">
        <span class="material-icons text-xl">dashboard</span> Dashboard
      </a>

      <div class="my-2 border-l-4 border-white ml-[-16px] pl-[12px]">
        <a routerLink="/add-user"
           class="flex items-center gap-3 px-4 py-3 bg-white text-brand-purple rounded-lg font-medium shadow-sm w-full">
          <span class="material-icons text-xl">person</span> User Management
        </a>
      </div>
    </nav>
    
    <div class="p-4 border-t border-white/10 mt-auto">
      <button (click)="logout()" class="flex items-center gap-3 px-4 py-3 text-white/80 hover:bg-white/10 rounded-lg font-medium transition-colors w-full">
        <span class="material-icons text-xl">logout</span> Sign Out
      </button>
    </div>
  </aside>

  <main class="flex-1 p-8 overflow-y-auto">

    <header class="flex justify-between items-center mb-8">
      <h1 class="text-2xl font-bold text-gray-900">User Configuration</h1>
      <div class="flex items-center gap-4 text-gray-500">
        <app-user-profile-avatar></app-user-profile-avatar>
      </div>
    </header>

    <div class="grid grid-cols-4 gap-6 mb-8 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <div class="text-center">
        <div class="text-gray-800 font-semibold mb-2">Total Users</div>
        <div class="text-5xl font-bold text-gray-900">{{ totalUsers }}</div>
      </div>
      <div class="text-center">
        <div class="text-gray-800 font-semibold mb-2">Standard Users</div>
        <div class="text-5xl font-bold text-gray-900">{{ standardUsers }}</div>
      </div>
      <div class="text-center">
        <div class="text-gray-800 font-semibold mb-2">Admin Users</div>
        <div class="text-5xl font-bold text-gray-900">{{ adminUsers }}</div>
      </div>
      <div class="text-center">
        <div class="text-gray-800 font-semibold mb-2">Super Admins</div>
        <div class="text-5xl font-bold text-gray-900">{{ superAdmins }}</div>
      </div>
    </div>

    <div class="bg-white rounded-xl shadow-sm border border-gray-100 p-8">

      <div class="flex justify-between items-center mb-6">
        <h2 class="text-xl font-bold text-gray-900">Add New User</h2>
        <button class="text-gray-400 hover:text-gray-600 transition-colors">
          <span class="material-icons text-xl">close</span>
        </button>
      </div>

      <form (ngSubmit)="saveUser()">

        <div class="grid grid-cols-2 gap-6 mb-4">
          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">First Name</label>
            <input type="text"
                   [(ngModel)]="user.firstName"
                   name="firstName"
                   placeholder="First Name"
                   class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all">
          </div>
          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Last Name</label>
            <input type="text"
                   [(ngModel)]="user.lastName"
                   name="lastName"
                   placeholder="Last Name"
                   class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all">
          </div>
        </div>

        <div class="grid grid-cols-2 gap-6 mb-4">
          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Email Address</label>
            <input type="email"
                   [(ngModel)]="user.email"
                   name="email"
                   placeholder="someemail@liifecore.com"
                   class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all">
          </div>
          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Primary Phone Number</label>
            <div class="flex">
              <select [(ngModel)]="user.phoneCode"
                      name="phoneCode"
                      class="bg-gray-50 border border-gray-200 rounded-l-lg px-3 py-2.5 text-sm border-r-0 focus:outline-none">
                <option>+1</option>
                <option>+44</option>
              </select>
              <input type="text"
                     [(ngModel)]="user.phoneNumber"
                     name="phoneNumber"
                     placeholder="555 123 4567"
                     class="w-full bg-gray-50 border border-gray-200 rounded-r-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all">
            </div>
          </div>
        </div>

        <div class="grid grid-cols-2 gap-6 mb-4">
          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Employee ID / Member ID</label>
            <input type="text"
                   [(ngModel)]="user.employeeId"
                   name="employeeId"
                   class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all">
          </div>

          <div>
            <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">User Group / Role</label>
            <div class="relative">
              <select [(ngModel)]="user.role"
                      name="role"
                      class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm appearance-none focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all">
                <option value=""
                        disabled
                        selected>Select a Role</option>
                <option disabled>Admin</option>
                <option>Employee</option>
                <option>Recipient</option>
              </select>
              <span
                    class="material-icons absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none">expand_more</span>
            </div>
          </div>
        </div>

        <div class="mb-6">
          <label class="block text-xs font-bold text-gray-700 mb-1.5 ml-1">Additional Notes</label>
          <textarea [(ngModel)]="user.notes"
                    name="notes"
                    rows="3"
                    class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-purple/20 focus:border-brand-purple transition-all"></textarea>
        </div>


        <div class="flex justify-between pt-4 border-t border-gray-100">
          <button type="button"
                  (click)="cancel()"
                  class="px-10 py-2.5 border border-brand-purple text-brand-purple font-semibold rounded-lg hover:bg-purple-50 transition-colors">
            Cancel
          </button>
          <button type="submit"
                  class="px-10 py-2.5 bg-[#8b5cf6] text-white font-semibold rounded-lg hover:bg-purple-700 transition-colors shadow-md">
            Save
          </button>
        </div>

      </form>
    </div>

  </main>
</div>